import { Typography } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { If } from "lib/@components/switch"

export function VersionNumber() {
    const { isAvailable, locked } = useBoundContext()
    return (
        <If value={typeof isAvailable === "number" && !Number.isNaN(isAvailable) && !locked}>
            <Typography component="div" variant="caption" data-cy="lifecycle-version-number">
                Version {isAvailable}
            </Typography>
        </If>
    )
}
